import { useNavigate } from 'react-router'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { LINK_CLICK_TO_TEXT_HELP_GUIDE } from 'shared/constants/links'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ClickToTextRoutes } from 'pages/clickToText/route/type'

type IClickToTextButtonProps = {
  className?: string
}

export const ClickToTextNewButton = observer(({ className }: IClickToTextButtonProps) => {
  const navigate = useNavigate()
  const entities = useEntitiesContext()
  const { eventLogStore, organizationStore } = entities

  const handleClick = () => {
    eventLogStore.logEvent(
      'Click to Text Used',
      {
        event_id: 'click_to_text_used',
        action: 'New link clicked',
        agencyId: organizationStore.agency_id,
      },
      { groupId: organizationStore.id }
    )
    navigate(`/${ClickToTextRoutes.root}/${ClickToTextRoutes.create}`)
  }

  return (
    <Button
      text='New link'
      iconProps={{ icon: 'add' }}
      size='medium'
      onClick={handleClick}
      className={className}
    />
  )
})

export const ClickToTextHelpGuideButton = ({ className }: IClickToTextButtonProps) => (
  <Button
    tag='a'
    text='Help guide'
    size='medium'
    contained='tertiary'
    className={className}
    style={{ textDecoration: 'none' }}
    href={LINK_CLICK_TO_TEXT_HELP_GUIDE}
    target='_blank'
    rel='noreferrer'
    iconProps={{ icon: 'info' }}
  />
)
